module.exports = __webpack_public_path__ + "img/gy.bbdc6a13.png";